"use client"

import { Dam } from "lucide-react"
import { component, Icon } from "../icon"

/**
 * `DamIcon` is [Lucide](https://lucide.dev) SVG icon component.
 *
 * @see https://yamada-ui.com/docs/components/icon
 */
export const DamIcon = component(Icon)({ as: Dam })
